import { BASE_ENDPOINT } from "../../../endpoint";

export const retrieveOtherMFICustomerService = async (
	token: string,
	institutionId: string,
	customerId: string,
	signal?: any
) => {
	try {
		if (!institutionId.trim()) return;
		const response = await fetch(
			`${BASE_ENDPOINT}/user/customerservice/customer/${institutionId}/${customerId}`,
			{
				method: "GET",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
				signal: signal,
			}
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res.data;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
